import { Box } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE, DUR } from '../../theme/tokens';

// ---------------------------------------------------------------------------
// Apariția la derulare: conținutul urcă puțin și se aprinde, o singură dată.
//
// Deplasarea e mică (18px) și intenționat scurtă. O secțiune care zboară de la
// 60px distanță arată spectaculos la prima vizită și obosește la a doua, iar pe
// telefon, unde derulezi repede, elementele ajung să apară după ce le-ai
// depășit deja. `margin: -8%` pornește animația chiar înainte ca elementul să
// intre complet în ecran, ca să fie deja terminată când ajunge la ochi.
//
// La `prefers-reduced-motion` nu se animează nimic: conținutul e pur și simplu
// acolo. Nu ascundem niciodată text în spatele unei animații care ar putea să
// nu pornească.
// ---------------------------------------------------------------------------
export default function Reveal({
  children,
  delay = 0,
  y = 18,
  duration = DUR.slow,
  sx,
  component = 'div',
  ...rest
}) {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <Box component={component} sx={sx} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      component={motion[component] || motion.div}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-8% 0px -8% 0px' }}
      transition={{ duration, delay, ease: EASE }}
      sx={sx}
      {...rest}
    >
      {children}
    </Box>
  );
}
